import React, { useState } from 'react'
import { DefaultResponse, UserInfoResponse } from '../../model/dto/response';
import { Form } from 'semantic-ui-react';
import { FormErrorHeader } from '../generic/form-error-header';
import InformationBandeau from '../generic/information-bandeau/information-bandeau';
import { StatutSca } from '../../model/entities/statut-sca';
import { AuthenticationState } from '../../model/state/authentication-state';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { AdresseMailRegistrationBody } from '../../model/dto/body/adresse-mail-registration-body';
import { InputField } from '../generic/input-field';
import { SubmitButton } from '../generic/submit-button';
import { SimpleButton } from '../generic/simple-button';
import { userService } from '../../services/authentication-redux-service';
type Props = {
  userInfo?: UserInfoResponse;
    onActionSuccess: (response : DefaultResponse) => void
    onSkipAction?: () => void
}

type FieldData = {
    value?: any,
    name?: string,
    isValid?: boolean
  };
  
  type FormData = {
    Mail: FieldData,
  }

export default function ChangeMailFormV2({userInfo, onActionSuccess, onSkipAction}: Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
    const [form, setForm] = useState<FormData>({
    Mail : { name : "Mail", value : "", isValid: true},
    })
    const [isFormError, setIsFormError] = useState(false);

    function isFormValid() : boolean {
        const regex = /^[\w.+-]{1,64}@([a-zA-Z\d-]{2,252}\.[a-zA-Z\.]{2,7})$/
        if(!regex.test(form.Mail.value)) {
          setIsFormError(true)
          return false
        }
        setIsFormError(false)
        return true
    }

    const handleInputMailChange = (e: React.ChangeEvent<HTMLInputElement>,
        fieldName?: string,
        isValid?: boolean): void => {
            const fieldValue = e.target.value;
            const newField: FieldData = {
            [fieldName!]: { value: fieldValue, name: fieldName, isValid: isValid },
            };
            
            setForm({...form,...newField});
            setIsFormError(false);
    }

    const onFormNotValid = (): void => {
        setIsFormError(true);
    };

    const body: AdresseMailRegistrationBody = {
        Mail : form.Mail.value
    }

    const notVerifiedMailMessage = `Vous vous apprêtez à modifier votre adresse mail. Un nouvel email vous sera envoyé à cette adresse pour la vérification.`
    const verifiedMailMessage = `Vous vous apprêtez à modifier votre adresse mail. Si vous validez ce choix, vous devrez de nouveau vérifier votre adresse mail via le lien présent dans le nouveau mail qui vous sera envoyé”.`
    const scaValidatedMessage = `De plus, la sécurité de votre compte est déjà validée. Tout changement d’adresse mail nécessitera à nouveau de procéder à la sécurisation de votre compte. Tant que cela ne sera pas fait, il ne vous sera pas possible d’effectuer un investissement ou de retirer des fonds.`

    const returnMessageInfo = () => {
        let finalMessage: string
        if(userInfo?.IsMailValid){
            finalMessage = verifiedMailMessage
        }else { 
            finalMessage = notVerifiedMailMessage
        }

        if(userInfo?.StatutScaCode === StatutSca.VALIDE){
            finalMessage = `${finalMessage} ${scaValidatedMessage}`
        }
        return finalMessage
    }
    return (
    <Form>
        <FormErrorHeader
            message="Le format de l'adresse email est incorrect"
            displayed={isFormError}
        />
        <InformationBandeau 
            type="information"
            icon={{name:'info circle', size:"big", color:"blue"}}
            message={returnMessageInfo()}
        />
        <InputField
            label='Adresse email' 
            data={form.Mail} 
            type="email"
            onChange={handleInputMailChange}    
            inputCss={'max-width: 150px'}
        />
        <div style={{marginTop: 20, display: 'flex'}}>
        {userInfo?.IsAdressePostaleDone && userInfo.IsIdentiteDone && 
        <SubmitButton
          data={body}
          action={() => {return userService.updateUserEmail(body, loginProps?.oauth?.userId, loginProps?.oauth)}}
          label='Valider mon email'
          validateForm={isFormValid}
          onFormNotValid={onFormNotValid}
          onActionSuccess={onActionSuccess}
        />
        }
          <SimpleButton
            label={"Annuler"}
            onClick={onSkipAction}
          />
      </div>  
    </Form>
  )
}
